<div class="report-unavailable" role="status">
  <img class="report-unavailable__image" src="/assets/images/no-sales-on-your-records-yet.png" alt="" />

  <!-- One text run, so no stray spaces around the link or before the period. -->
  <!-- prettier-ignore -->
  <p class="report-unavailable__text">{{ textSig() }} If you believe this is incorrect, contact Mark&nbsp;Powell at <a class="report-unavailable__link" href="mailto:mark@alliancegrouplife.com">mark&#64;alliancegrouplife.com</a>.</p>
</div>
